import React from 'react'
import {BsThreeDotsVertical} from 'react-icons/bs'
const Friends = () => {
  return (
    <div className='bg-primary w-full pb-4  relative rounded-xl	'>
    <h1 className='text-white text-xl font-pop font-semibold ml-4'>Friends</h1>
    <BsThreeDotsVertical className='absolute top-1 right-6 text-xl text-white'/>
 
   <div className=' h-[451px] overflow-y-scroll'>
    
   <div className='bg-white w-80 mx-auto rounded-xl mt-4 flex'>
     <image>
     <img className='rounded-full ml-2' src="images/group.png" alt="group" />
     </image>
     <div className="ml-3.5 mt-2">
         <h1 className='  font-pop font-semibold text-lg'>Friends Reunion </h1>
         <h2 className='font-pop font-medium text-sm'>Hi Guys, Wassup!</h2>
     </div>
     <div className='flex items-center  ml-4 '>
     <button className='px-2 py-1 bg-primary rounded-xl text-white'>Accept</button>
     </div>
     
     
    </div>

   <div className='bg-white w-80 mx-auto rounded-xl mt-4 flex'>
     <image>
     <img className='rounded-full ml-2' src="images/group.png" alt="group" />
     </image>
     <div className="ml-3.5 mt-2">
         <h1 className='  font-pop font-semibold text-lg'>Friends Reunion </h1>
         <h2 className='font-pop font-medium text-sm'>Hi Guys, Wassup!</h2>
     </div>
     <div className='flex items-center  ml-4 '>
     <button className='px-2 py-1 bg-primary rounded-xl text-white'>Accept</button>
     </div>
     
     
    </div>

   <div className='bg-white w-80 mx-auto rounded-xl mt-4 flex'>
     <image>
     <img className='rounded-full ml-2' src="images/group.png" alt="group" />
     </image>
     <div className="ml-3.5 mt-2">
         <h1 className='  font-pop font-semibold text-lg'>Friends Reunion </h1>
         <h2 className='font-pop font-medium text-sm'>Hi Guys, Wassup!</h2>
     </div>
     <div className='flex items-center  ml-4 '>
     <button className='px-2 py-1 bg-primary rounded-xl text-white'>Accept</button>
     </div>
     
     
    </div>

   <div className='bg-white w-80 mx-auto rounded-xl mt-4 flex'>
     <image>
     <img className='rounded-full ml-2' src="images/group.png" alt="group" />
     </image>
     <div className="ml-3.5 mt-2">
         <h1 className='  font-pop font-semibold text-lg'>Friends Reunion </h1>
         <h2 className='font-pop font-medium text-sm'>Hi Guys, Wassup!</h2>
     </div>
     <div className='flex items-center  ml-4 '>
     <button className='px-2 py-1 bg-primary rounded-xl text-white'>Accept</button>
     </div>
     
     
    </div>

   <div className='bg-white w-80 mx-auto rounded-xl mt-4 flex'>
     <image>
     <img className='rounded-full ml-2' src="images/group.png" alt="group" />
     </image>
     <div className="ml-3.5 mt-2">
         <h1 className='  font-pop font-semibold text-lg'>Friends Reunion </h1>
         <h2 className='font-pop font-medium text-sm'>Hi Guys, Wassup!</h2>
     </div>
     <div className='flex items-center  ml-4 '>
     <button className='px-2 py-1 bg-primary rounded-xl text-white'>Accept</button>
     </div>
     
     
    </div>

   <div className='bg-white w-80 mx-auto rounded-xl mt-4 flex'>
     <image>
     <img className='rounded-full ml-2' src="images/group.png" alt="group" />
     </image>
     <div className="ml-3.5 mt-2">
         <h1 className='  font-pop font-semibold text-lg'>Friends Reunion </h1>
         <h2 className='font-pop font-medium text-sm'>Hi Guys, Wassup!</h2>
     </div>
     <div className='flex items-center  ml-4 '>
     <button className='px-2 py-1 bg-primary rounded-xl text-white'>Accept</button>
     </div>
     
     
    </div>
   </div>
     </div>
  )
}

export default Friends